import { z } from "zod";

const ACCEPTED_IMAGE_TYPES = ["jpeg", "jpg", "png", "webp"];
const ImgSchema = z.object({
  fileName: z.string(),
  name: z.string(),
  fileSize: z.number(),
  size: z.number(),
  key: z.string(),
});
export const IMG_MAX_LIMIT = 1;

export const eventSchema = z.object({
  title: z
    .string({ required_error: "Le titre est obligatoire" })
    .min(3, { message: "Le titre doit comporter au moins 3 caractères." }),
  date: z.date({
    required_error: "La date est obligatoire",
  }),
  description: z.string({ required_error: "La description est obligatoire" }),
  tag: z.string({ required_error: "La catégorie est obligatoire" }),

  image: z
      .array(ImgSchema)
      .max(IMG_MAX_LIMIT, {
        message: "Vous ne pouvez ajouter qu'une seule image.",
      })
      .min(1, { message: "Au moins une image doit être ajoutée." })
      .refine(
        (images) => {
          // Only validate if images are present
          if (images && images.length > 0) {
            const invalidImages = images.filter((img) => {
              const fileExtension = img.fileName
                .split(".")
                .pop()
                ?.toLowerCase();
              return (
                fileExtension && !ACCEPTED_IMAGE_TYPES.includes(fileExtension)
              );
            });
            return invalidImages.length === 0;
          }
          // If images is undefined or empty, don't apply any validation.
          return true;
        },
        {
          message: "Le type de fichier de l'image n'est pas pris en charge.",
        }
      )
      .optional(),
});

export type EventFormValues = z.infer<typeof eventSchema>;

export const updateEventSchema = z
  .object({
    title: z
      .string()
      .min(3, { message: "Le titre doit comporter au moins 3 caractères." }),
    date: z.date({
      required_error: "La date est obligatoire",
    }),
    tag: z.string({ required_error: "Tag est obligatoire" }),
    description: z.string({ required_error: "Description est obligatoire" }),

    image: z
      .array(ImgSchema)
      .max(IMG_MAX_LIMIT, {
        message: "Vous ne pouvez ajouter qu'une seule image.",
      })
      .min(1, { message: "Au moins une image doit être ajoutée." })
      .refine(
        (images) => {
          // Only validate if images are present
          if (images && images.length > 0) {
            const invalidImages = images.filter((img) => {
              const fileExtension = img.fileName
                .split(".")
                .pop()
                ?.toLowerCase();
              return (
                fileExtension && !ACCEPTED_IMAGE_TYPES.includes(fileExtension)
              );
            });
            return invalidImages.length === 0;
          }
          // If images is undefined or empty, don't apply any validation.
          return true;
        },
        {
          message: "Le type de fichier de l'image n'est pas pris en charge.",
        }
      )
      .optional(), // Allow image to be optional.
  })
  .partial(); // All fields are now optional

export type UpdateEventFormValues = z.infer<typeof updateEventSchema>;
